import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { Support } from '../Api/Support';
import { Flip, toast } from 'react-toastify';
import { Complain } from '../Api/Complain';
import { Helmet } from 'react-helmet';
export default function HelpSupport() {
    const navigate = useNavigate();
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const { setLoad, setLoadColor } = useContext(Context);
    const [complainList, setComplainList] = useState([]);
    const { pathname } = useLocation();

    const handleSubmit = async () => {
        setLoad(true);
        setLoadColor("#434343");
        let data = {
            "username": JSON.parse(localStorage.getItem('userinfo'))?.username,
            "subject": subject,
            "message": message,
            "img": ""
        };
        let res = await Support(data);
        if (res) {
            if (res.data.status) {
                toast.success('Request Submit Successfully', {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
                setMessage("");
                setSubject("");
                navigate("/game");
            } else {
                toast.error(res.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
            }
            setLoad(false);
        }
        setLoad(false);
    };

    const handleComplain = useCallback(async () => {
        setLoad(true);
        setLoadColor("#434343");
        let data = {
            "username": JSON.parse(localStorage.getItem('userinfo'))?.username
        };
        let res = await Complain(data);
        if (res) {
            if (res.data.status) {
                setComplainList(res.data.data);
            } else {
                toast.error(res.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
            }
            setLoad(false);
        }
        setLoad(false);
    }, [setLoad, setLoadColor]); // Add setLoad and setLoadColor to the dependencies

    useEffect(() => {
        if (pathname === '/helpSupport') {
            handleComplain();
        }
    }, [pathname, handleComplain]); // Add handleComplain to the dependencies

    return (
        <>
            <Helmet>
                {/* Page Title */}
                <title>Help and Support | Contact Jantri Team | Matka Jantri</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="Get assistance from the MatkaJantri support team for any issues related to the APK. Reach out for help and support anytime."
                />

                {/* SEO Directives */}
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://app.matkajantri.com/help-and-support" />

                {/* Favicon and Icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Help and Support | Contact Jantri Team | MatkaJantri" />
                <meta
                    property="og:description"
                    content="Get assistance from the MatkaJantri support team for any issues related to the APK. Reach out for help and support anytime."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://app.matkajantri.com" />
                <meta property="og:image" content="https://app.matkajantri.com/Logo.png" />
                <meta name="google-site-verification" content="d6d81656210c6db7" />
            </Helmet>

            <div className='depositContainer'>
                <div className="wrapper" style={{ marginTop: "0px" }}>
                    <div className="section">
                        <div className="top_navbar" style={{ height: "60px", zIndex: "111" }}>
                            <div className="hamburger">
                                <button
                                    type="button"
                                    className="back_btn"
                                    onClick={() => navigate("/game")}
                                >
                                    <i className="fa-solid fa-chevron-left"></i>
                                </button>
                            </div>
                            <div className='gameName'>Help And Support</div>
                        </div>
                    </div>
                </div>

                <div className="container" style={{ position: "relative", top: "75px" }}>
                    <h2>Send Message</h2>
                    <div>
                        <div className="form-group">
                            <label htmlFor="subject">Subject:</label>
                            <input
                                type="text"
                                id="subject"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                placeholder="Enter subject..."
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">Message:</label>
                            <textarea
                                id="message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Enter your message..."
                            ></textarea>
                        </div>
                        <button type="submit" className="btn-submit" onClick={handleSubmit}>Send</button>
                    </div>
                </div>

                <div className="Tablecontainer" style={{ marginTop: "150px", width: "100%" }}>
                    <table>
                        <thead>
                            <tr>
                                <th>Ticket ID</th>
                                <th>Subject</th>
                                <th>Message</th>
                                <th>Time</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {complainList?.map((ele, i) => (
                                <tr key={i}>
                                    <td>{ele?._id.slice(0, 5)}</td>
                                    <td>{ele?.subject}</td>
                                    <td>{ele?.message}</td>
                                    <td>{new Date(ele?.createdAt).toUTCString()}</td>
                                    <td>
                                        {ele?.status === 0 && <button type="button" className="btn btn-warning btnyellow-custom">Pending</button>}
                                        {ele?.status === 1 && <button type="button" className="btn btn-success btngreen-success-custom">Success</button>}
                                        {ele?.status === 2 && <button type="button" className="btn btn-danger btnred-danger-custom">Rejected</button>}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
